/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { collectionSourceSchema } from './collection-source';
import { collectionStatusSchema } from './collection-status';
import { collectionTypeSchema } from './collection-type';

export const baseCollectionBodySchema = z.object({
  parentId: z.number().nullable().optional(),
  title: z.string().min(1),
  slug: z.string().min(1).optional(),
  description: z.string().nullable().optional(),
  type: collectionTypeSchema,
  subject: z.string().nullable().optional(),
  category: z.string().nullable().optional(),
  difficulty: z.string().nullable().optional(),
  year: z.number().nullable().optional(),
  posterPath: z.string().nullable().optional(),
  backdropPath: z.string().nullable().optional(),
  thumbnailPath: z.string().nullable().optional(),
  logoPath: z.string().nullable().optional(),
  trailerPath: z.string().nullable().optional(),
  genre: z.string().nullable().optional(),
  rating: z.string().nullable().optional(),
  tagline: z.string().nullable().optional(),
  source: collectionSourceSchema.nullable().optional(),
  isFeatured: z.number().optional(),
  isPremium: z.number().optional(),
  titleInPoster: z.number().optional(),
  status: collectionStatusSchema.optional(),
  sortOrder: z.number().optional(),
});

export type IBaseCollectionBody = z.infer<typeof baseCollectionBodySchema>;
